import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

export const PhoneRepairIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M6 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5z' />
    <path d='M11 4h2' />
    <path d='M12 17v.01' />
  </Icon>
);

export default PhoneRepairIcon;
